export { default as LandingLayout } from './Layout';